/* ECLISS — product & interactive sections */
(() => {
  const EC = (window.EC = window.EC || {});
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (c) => (EC.money ? EC.money(c) : (c / 100).toFixed(2) + ' €');

  /* Formules (kit, Duo, recharge) / quantity */
  const applyBundle = (box) => {
    const sel = $('[data-bundles] input:checked', box);
    const qtyInput = $('input[name="quantity"]', box);
    const idInput = $('input[name="id"]', box);
    let total, compare, qty;
    if (sel) {
      qty = Number(sel.dataset.qty || sel.value) || 1; total = Number(sel.dataset.total); compare = Number(sel.dataset.compare);
    } else {
      qty = Number(qtyInput ? qtyInput.value : 1) || 1;
      const unit = Number(box.dataset.price || 0), unitC = Number(box.dataset.compare || 0);
      total = unit * qty; compare = Math.max(unitC, unit) * qty;
    }
    if (qtyInput && sel) qtyInput.value = qty;
    if (idInput && sel && sel.dataset.variant) idInput.value = sel.dataset.variant;
    const label = sel ? sel.dataset.label : '';
    const scope = [box].concat(box.id ? $$('[data-sticky-for="' + box.id + '"]') : []);
    scope.forEach((root) => {
      $$('[data-atc-price]', root).forEach((el) => (el.textContent = money(total)));
      $$('[data-atc-compare]', root).forEach((el) => { el.textContent = compare > total ? money(compare) : ''; el.hidden = !(compare > total); });
      $$('[data-atc-label]', root).forEach((el) => { if (label) el.textContent = label; });
    });
    $$('[data-bundles] .bndl__opt', box).forEach((o) => o.classList.toggle('is-active', !!$('input:checked', o)));
    if (!sel) return;
    $$('[data-note]', box).forEach((n) => (n.hidden = n.dataset.note !== sel.value));
    const kit = box.id ? $('[data-kit-for="' + box.id + '"]') : null;
    if (kit) {
      const mode = sel.dataset.kit || 'full';
      $$('[data-kit-mode]', kit).forEach((el) => (el.hidden = el.dataset.kitMode !== mode));
      $$('[data-acc]', kit).forEach((li) => li.classList.toggle('is-out', mode === 'refill'));
    }
  };

  const initBuyboxes = (root = document) => {
    $$('[data-buybox]', root).forEach((box) => {
      if (box.dataset.init) return; box.dataset.init = 1;
      box.addEventListener('change', (e) => {
        if (e.target.closest('[data-bundles]') || e.target.name === 'quantity') applyBundle(box);
        if (e.target.matches('select[name="id"]')) {
          const o = e.target.selectedOptions[0];
          box.dataset.price = o.dataset.price; box.dataset.compare = o.dataset.compare || 0;
          applyBundle(box);
        }
      });
      box.addEventListener('click', (e) => {
        const pk = e.target.closest('[data-pick]');
        if (pk) {
          const r = $('[data-bundles] input[value="' + pk.dataset.pick + '"]', box);
          if (r) { r.checked = true; applyBundle(box); r.focus(); }
          return;
        }
        const s = e.target.closest('[data-qty-step]');
        if (!s) return;
        const i = $('input[name="quantity"]', box);
        i.value = Math.max(1, (Number(i.value) || 1) + Number(s.dataset.qtyStep));
        applyBundle(box);
      });
      applyBundle(box);

      const main = $('[data-main-atc]', box);
      const sticky = box.id ? $('[data-sticky-for="' + box.id + '"]') : null;
      if (main && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          document.body.classList.toggle('has-satc', past);
        }).observe(main);
        sticky.addEventListener('click', (e) => {
          if (!e.target.closest('[data-sticky-submit]')) return;
          const f = $('form[data-ec-form]', box);
          if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
        });
      }
    });
  };

  /* Gallery */
  const initGalleries = (root = document) => {
    $$('[data-gallery]', root).forEach((g) => {
      if (g.dataset.init) return; g.dataset.init = 1;
      const track = $('[data-gallery-track]', g);
      if (!track) return;
      const slides = $$('.pg__slide', track);
      const thumbs = $$('[data-thumb]', g);
      const dots = $$('[data-dot]', g);
      const count = $('[data-gallery-count]', g);
      let idx = 0;
      const setActive = (i) => {
        idx = i;
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        const th = thumbs[i];
        if (th && th.parentElement) {
          const p = th.parentElement;
          if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: th.offsetTop - p.clientHeight / 2 + th.clientHeight / 2, behavior: 'smooth' });
          else if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
        }
      };
      const go = (i) => {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      };
      let t;
      track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 60);
      }, { passive: true });
      thumbs.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.thumb))));
      const p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
      p && p.addEventListener('click', () => go(idx - 1));
      n && n.addEventListener('click', () => go(idx + 1));
      setActive(0);
    });
  };

  /* Before / after */
  const initBA = (root = document) => {
    $$('[data-ba]', root).forEach((ba) => {
      if (ba.dataset.init) return; ba.dataset.init = 1;
      const r = $('[data-ba-range]', ba);
      if (!r) return;
      const set = () => ba.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  };

  /* Autoplay videos when visible */
  let vio;
  const initVideos = (root = document) => {
    const vids = $$('video[data-ec-autoplay]', root);
    if (!vids.length) return;
    if (!vio && 'IntersectionObserver' in window) {
      vio = new IntersectionObserver((es) => es.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'metadata'; const pr = v.play(); pr && pr.catch(() => {}); }
        else v.pause();
      }), { threshold: 0.35 });
    }
    vids.forEach((v) => { if (v.dataset.init) return; v.dataset.init = 1; vio ? vio.observe(v) : v.play(); });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-unmute]');
    if (!b) return;
    const card = b.closest('.vcard');
    const v = card && $('video', card);
    if (!v) return;
    $$('video[data-ec-autoplay]').forEach((o) => { if (o !== v) { o.muted = true; const oc = o.closest('.vcard'); const ob = oc && $('[data-unmute]', oc); ob && ob.classList.remove('is-on'); } });
    v.muted = !v.muted;
    if (!v.muted) { v.currentTime = 0; v.play(); }
    b.classList.toggle('is-on', !v.muted);
  });

  /* Shipping cut-off & delivery estimate (business days) */
  const isBiz = (d) => d.getDay() !== 0 && d.getDay() !== 6;
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; };
  const fmt = (d, o) => d.toLocaleDateString('fr-FR', o || { weekday: 'short', day: 'numeric', month: 'short' });
  const renderShip = (box) => {
    const now = new Date();
    const cutoff = Number(box.dataset.cutoff || 0);
    const sameDay = cutoff > 0 && isBiz(now) && now.getHours() < cutoff;
    const ship = sameDay ? now : addBiz(now, 1);
    const eta = $('[data-eta]', box);
    if (eta) eta.textContent = fmt(addBiz(ship, Number(box.dataset.min || 2))) + ' et le ' + fmt(addBiz(ship, Number(box.dataset.max || 5)));
    const msg = $('[data-ship-msg]', box);
    if (!msg || !cutoff) return;
    if (sameDay) {
      const end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      const mins = Math.max(1, Math.round((end - now) / 60000));
      const h = Math.floor(mins / 60), m = mins % 60;
      msg.innerHTML = 'Commandez dans <strong>' + (h ? h + ' h ' : '') + m + ' min</strong> : expédié aujourd’hui';
    } else {
      msg.innerHTML = 'Commandez maintenant : expédié <strong>' + fmt(ship, { weekday: 'long', day: 'numeric', month: 'long' }) + '</strong>';
    }
  };
  const initShip = (root = document) => {
    $$('[data-ship]', root).forEach((box) => {
      renderShip(box);
      if (!box.dataset.init) { box.dataset.init = 1; setInterval(() => renderShip(box), 30000); }
    });
  };

  /* Hotspots */
  const initHotspots = (root = document) => {
    $$('[data-hs-wrap]', root).forEach((w) => {
      if (w.dataset.init) return; w.dataset.init = 1;
      const act = (i) => {
        $$('[data-hs]', w).forEach((b) => b.classList.toggle('is-active', b.dataset.hs === i));
        $$('[data-hs-item]', w).forEach((li) => li.classList.toggle('is-active', li.dataset.hsItem === i));
      };
      w.addEventListener('click', (e) => { const b = e.target.closest('[data-hs],[data-hs-item]'); if (b) act(b.dataset.hs || b.dataset.hsItem); });
      w.addEventListener('mouseover', (e) => { const b = e.target.closest('[data-hs],[data-hs-item]'); if (b) act(b.dataset.hs || b.dataset.hsItem); });
      act('0');
    });
  };

  const init = (root) => { initBuyboxes(root); initGalleries(root); initBA(root); initVideos(root); initShip(root); initHotspots(root); };
  document.addEventListener('ec:init', (e) => init(e.detail || document));
  if (window.EC && EC.init && document.readyState !== 'loading') init(document);
})();